import { AxiosError, AxiosResponse } from 'axios';

export const authResponseError = (error: AxiosError) => {
  const { response, config } = error;

  if (response?.status === 401 && !config.url?.endsWith('/auth/login')) {
    const url =
      window.location.origin +
      '/auth/sign-in?redirect=' +
      encodeURI(window.location.pathname);
    window.location.href = url;
  }
  return Promise.reject(error);
};

export const authResponseSuccess = (response: AxiosResponse) => {
  return response;
};
